import { useEffect, useState } from 'react';

type CopyState = 'idle' | 'copied';

const COPY_MESSAGE_TIMEOUT = 1000;

export const useClipboard = (text: string) => {
  const [state, setClipboard] = useState<CopyState>('idle');

  useEffect(() => {
    if (state === 'idle') return;

    const timeout = globalThis.setTimeout(() => {
      setClipboard('idle');
    }, COPY_MESSAGE_TIMEOUT);

    return () => {
      globalThis.clearTimeout(timeout);
    };
  }, [state]);

  const copyToClipboard = () => {
    void (async () => {
      await navigator.clipboard.writeText(text);
      setClipboard('copied');
    })();
  };

  return { state, copyToClipboard };
};
